var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"9","viewBox":"0 0 9 12","fill":"#fff","stroke":"#fff","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1 7l4.5-7-1 5h3l-5 6.5L4 7H1z","fill":"inherit","stroke":"inherit"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }